import { DatesProvider } from '@mantine/dates'
import { useLingui } from '@lingui/react'

interface Props {
  children: React.ReactNode
}

export function LocaleAwareProviders({ children }: Props) {
  const { i18n } = useLingui()

  return (
    <DatesProvider
      settings={{
        locale: i18n.locale,
        firstDayOfWeek: 1,
        weekendDays: [0, 6],
        consistentWeeks: true,
      }}
    >
      {children}
    </DatesProvider>
  )
}
